<template>
  <div class="card">
    <div class="card-header card-header-with-icons">
      <h4>Projektphasen</h4>
      <div class="admin-icons" v-if="isAdmin">
        <feather class="infra-blue pointer" size="20" type="plus" @click="openModal('addPhase')"></feather>
      </div>
    </div>
    <div class="card-body">
      <div class="timeline-small">
        <div class="no-items" v-if="!bp_phasen.length">Keine Phasen definiert</div>
        <transition :name="animations.slideDown.name" :enter="animations.slideDown.enter" :leave="animations.slideDown.leave">
          <div class="timeline_container" v-if="readyState">
            <div class="media" v-for="phase in pages[currentPage - 1]" :key="'phase_' + phase.id">
              <div class="timeline-round m-r-30 timeline-line-1 bg-secondary"><feather type="map"></feather></div>
              <div class="media-body">
                <h6>
                  {{ phase.titel }}
                  <div class="pull-right f14">
                    <span class="f-14">{{ transformDate(phase.created_on, "date") }}</span>
                    <div
                      style="margin-left:5px;display:inline-block;vertical-align:middle;"
                      v-if="isAdmin"
                      @click="openEditModal(cloneNonReactive(phase))"
                    >
                      <feather type="edit-2" size="15" class="infra-blue pointer"></feather>
                    </div>
                  </div>
                </h6>
                <div class="phasen-image-container" v-if="phase.imageData">
                  <img :src="phase.imageData.thumbnails[3].url" class="pointer" @click="openImageModal(cloneNonReactive(phase))" />
                </div>
                <p v-html="phase.kommentar">{{ phase.kommentar }}</p>
              </div>
            </div>
          </div>
        </transition>
        <div id="iam-pagination" v-if="pages.length > 1">
          <div
            v-for="(page, index) in pages.length"
            :key="'btn_page_' + index"
            class="pagination-button"
            @click="setCurrentPage(page)"
            :class="{ active: isCurrentPage(page) }"
          >
            {{ page }}
          </div>
        </div>
      </div>
      <div class="flex-row-end" style="margin-top:30px;">
        <b-button class="btn btn-primary" v-if="isAdmin" @click="openModal('addPhase')">Projektphase anlegen</b-button>
      </div>
    </div>
    <!-- MODAL ADD PHASE -->
    <b-modal id="addPhase" size="lg" @hide="resetModalState" @ok.prevent="createProjektphase">
      <div class="form-container">
        <label>Titel</label>
        <b-input-group class="form-input-group" prepend="Abc">
          <b-form-input
            class="form-control"
            v-model="modal.titel"
            v-bind:class="{ form_error: hasError('titel') }"
            name="titel"
            @blur="validate"
          ></b-form-input>
          <feather style="right:10px;position:absolute;top:5px;" type="check" v-if="!updating.titel && modal.titel" class="checkmark green"></feather>
          <Loader size="20" v-if="updating.titel" />
        </b-input-group>
        <label>Text</label>
        <div class="editor-container">
          <vue-editor
            :editorToolbar="editorOptions"
            v-model="modal.kommentar"
            v-bind:class="{ form_error: hasError('kommentar') }"
            name="kommentar"
            id="kommentar"
            @blur="validate"
          ></vue-editor>
          <feather type="check" v-if="!updating.kommentar && modal.kommentar.length" class="checkmark green editor-checkmark"></feather>
          <Loader size="20" v-if="updating.kommentar" class="loader" />
        </div>
        <div class="dropzone-container">
          <label>Bild (optional)</label>
          <vue-dropzone
            ref="phase_dropzone"
            :options="dropzone_options"
            id="phase_dropzone"
            class
            v-on:vdropzone-file-added="updating.image = true"
            v-on:vdropzone-success="processAsset"
          ></vue-dropzone>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="btn btn-warning" @click="closeModal('addPhase')">Abbrechen</b-button>
        <b-button :disabled="validation_success.length !== 2" @click="createProjektphase">Speichern</b-button>
      </template>
      <template slot="modal-header">
        <h4>Neue Projektphase hinzufügen</h4>
      </template>
    </b-modal>
    <!-- ENDE MODAL ADD PHASE -->

    <!-- IMAGE MODAL -->
    <b-modal id="imageModal" size="lg" @hide="imageModal = {}" v-if="readyState">
      <div class="image-modal-container">
        <div class="image">
          <img :src="imageModal.imageData.full_url" v-if="chk_exists(imageModal.imageData)" />
        </div>
        <div class="text" v-html="imageModal.kommentar">
          {{ imageModal.kommentar }}
        </div>
      </div>
      <template slot="modal-header">
        <h4>{{ imageModal.titel }}</h4>
      </template>
      <template v-slot:modal-footer>
        <b-button class="btn btn-primary" @click="closeModal('imageModal')">Schließen</b-button>
      </template>
    </b-modal>
    <!-- ENDE IMAGEMODAL -->

    <!-- MODAL EDIT PHASE -->
    <b-modal id="editPhase" size="lg" @hide="resetModalState">
      <div class="form-container">
        <label>Titel</label>
        <b-input-group class="form-input-group" prepend="Abc">
          <b-form-input
            class="form-control"
            v-model="modal.titel"
            v-bind:class="{ form_error: hasError('titel') }"
            name="titel"
            @blur="validate"
          ></b-form-input>
          <feather
            style="right:10px;position:absolute;top:5px;"
            type="check"
            v-if="!updating.titel && modal.titel.length"
            class="checkmark green"
          ></feather>
          <Loader size="20" v-if="updating.titel" />
        </b-input-group>
        <label>Text</label>
        <div class="editor-container">
          <vue-editor
            :editorToolbar="editorOptions"
            v-model="modal.kommentar"
            v-bind:class="{ form_error: hasError('kommentar') }"
            name="kommentar"
            id="kommentar"
            @blur="validate"
          ></vue-editor>
          <feather type="check" v-if="!updating.kommentar && modal.kommentar.length" class="checkmark green editor-checkmark"></feather>
          <Loader size="20" v-if="updating.kommentar" class="loader" />
        </div>
        <div class="dropzone-container">
          <label>Bild (optional)</label>
          <vue-dropzone
            ref="phase_dropzone"
            :options="dropzone_options"
            id="phase_dropzone"
            class
            v-on:vdropzone-file-added="updating.image = true"
            v-on:vdropzone-success="processAsset"
          ></vue-dropzone>
          <div class="dropzone-buttons">
            <feather type="trash" class="infra-blue pointer" id="dropzone-trash" @click="removeDropzoneImg"></feather>
            <b-tooltip target="dropzone-trash" placement="bottom">Bild entfernen</b-tooltip>
            <feather type="plus-circle" class="infra-blue pointer" id="dropzone-plus" @click="openDropzone"></feather>
            <b-tooltip target="dropzone-plus" placement="bottom">Neues Bild</b-tooltip>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="btn-warning" @click="closeModal('editPhase')">Abbrechen</b-button>
        <b-button :disabled="validation_errors.length > 0" @click="savePhase()">Speichern</b-button>
      </template>
      <template slot="modal-header">
        <h4>Neue Projektphase hinzufügen</h4>
      </template>
    </b-modal>
    <!-- ENDE MODAL EDIT PHASE -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import { VueEditor } from "vue2-editor";
import Loader from "@/components/loader.vue";

export default {
  name: "Projektphasen",
  props: ["bauprojekt_id"],
  components: {
    vueDropzone: vue2Dropzone,
    VueEditor,
    Loader,
  },
  data() {
    return {
      readyState: false,
      dzThumbSize: 200,
      bp_phasen: [],
      modal: {
        titel: "",
        kommentar: "",
        image: null,
      },
      imageModal: {
        titel: "",
        kommentar: "",
        image: null,
      },
      updating: {
        titel: false,
        kommentar: false,
        image: false,
      },
      validation_errors: [],
      validation_success: [],
      perPage: 2,
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters({
      phasen: "app/projektphasen",
      toasts: "app/toasts",
      api: "auth/apiSettings",
      editorOptions: "app/editorOptions",
      validation: "app/validation",
      isAdmin: "auth/isAdmin",
      animations: "app/animations",
    }),
    pageCount() {
      const result = Math.floor(this.bp_phasen.length / this.perPage);
      return result;
    },
    pages() {
      let runs = 0;
      let result = [];
      let pageArray = [];
      this.bp_phasen.forEach((p) => {
        if (runs == this.perPage) {
          runs = 0;
          result.push(pageArray);
          pageArray = [];
          pageArray.push(p);
          runs++;
        } else {
          pageArray.push(p);
          runs++;
        }
      });

      result.push(pageArray);
      return result;
    },
  },
  async created() {
    this.dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };
    try {
      await this.$store.dispatch("app/apiGetProjektphasen");
      this.getBpPhasen();
    } catch (error) {
      console.log(error);
      this.$toasted.show("Fehler beim Laden der Projektphasen", this.toasts.failure);
    }
  },
  methods: {
    isCurrentPage(page) {
      return page == this.currentPage;
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },
    async savePhase() {
      const payload = {
        collection: "projektphasen",
        item: this.modal.id,
        changes: {
          titel: this.modal.titel,
          kommentar: this.modal.kommentar,
          image: this.modal.image,
        },
      };
      try {
        await this.$store.dispatch("app/mutate", payload);
        await this.$store.dispatch("app/apiGetProjektphasen");
        await this.getBpPhasen();
        this.closeModal("editPhase");
      } catch (error) {
        this.$toasted.show("Fehler beim Speichern der Projektphase");
      }
    },
    openDropzone() {
      this.$refs.phase_dropzone.$el.click();
    },
    removeDropzoneImg() {
      this.$refs.phase_dropzone.removeAllFiles();
      this.modal.image = null;
      this.modal.imageData = null;
    },
    openImageModal(phase) {
      this.imageModal = phase;
      this.$bvModal.show("imageModal");
    },
    openEditModal(phase) {
      this.modal = phase;
      if (phase.image) {
        this.assignExistingImage(phase.image);
      }
      this.$bvModal.show("editPhase");
    },
    async assignExistingImage(imageID) {
      let editPhaseImg = null;

      try {
        editPhaseImg = await this.$directus.getItem("directus_files", imageID);
      } catch (error) {
        this.$toasted.show("Fehler beim Herunterladen des Bildes", this.toast.failure);
      }

      if (editPhaseImg.data) {
        const file = {
          size: editPhaseImg.data.filesize,
          name: editPhaseImg.data.title,
          type: editPhaseImg.data.type,
        };
        this.$refs.phase_dropzone.manuallyAddFile(file, editPhaseImg.data.data.full_url);
      }
    },
    async getBpPhasen() {
      this.readyState = false;
      const filtered = this.phasen.filter((phase) => phase.bauprojekt == this.bauprojekt_id);
      const sorted = filtered.sort((a, b) => {
        return new Date(b.created_on) - new Date(a.created_on);
      });
      this.bp_phasen = sorted;
      await this.assignImages();
      this.readyState = true;
    },
    async assignImages() {
      for (let idx = 0; idx < this.bp_phasen.length; idx++) {
        if (this.bp_phasen[idx].image !== null) {
          try {
            const response = await this.$store.dispatch("app/getAsset", this.bp_phasen[idx].image);
            this.bp_phasen[idx].imageData = this.cloneNonReactive(response);
          } catch (error) {
            console.log(error);
            this.$toasted.show("Fehler beim Erstellen der Bilddaten", this.toasts.failure);
          }
        }
      }
    },
    openModal(modal) {
      this.$bvModal.show(modal);
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },
    resetModalState() {
      this.modal = {
        titel: "",
        kommentar: "",
        image: null,
      };
      this.validation_errors = [];
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async validate(blur) {
      let fieldName = null;
      //check where to find the field name
      if ("undefined" !== typeof blur.container) fieldName = blur.container.id;
      if ("undefined" !== typeof blur.target) fieldName = blur.target.name;

      if (!fieldName.length) this.$toasted.show("Fehler bei der Feldvalidierung", this.toasts.failure);

      const validationExists = this.validation_success.indexOf(fieldName);
      if (validationExists > -1) this.validation_success.splice(validationExists, 1);
      const errorExists = this.validation_errors.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);
      this.updating[fieldName] = true;

      const validationPayload = {
        context: "phasen",
        field: fieldName,
        value: this.modal[fieldName],
      };

      try {
        const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
        if (!validation_result) this.validation_errors.push(fieldName);
        if (validation_result) this.validation_success.push(fieldName);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler bei der Feldvalidierung", this.toasts.failure);
      } finally {
        this.updating[fieldName] = false;
      }
    },
    async processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toasts.success);

      try {
        const updateBildTag = {
          tags: ["projektphase"],
        };

        await this.$directus.updateItem("directus_files", data.data.id, updateBildTag);
        this.modal.image = data.data.id;
        this.updating.image = false;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Zuweisen des Phasenbildes", this.toasts.failure);
      }
    },
    async createProjektphase() {
      const createPayload = {
        ...this.modal,
        bauprojekt: this.bauprojekt_id,
        status: "published",
      };

      try {
        await this.$directus.createItem("projektphasen", createPayload);
        await this.$store.dispatch("app/apiGetProjektphasen");
        this.getBpPhasen();
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Bauprojekts.", this.toasts.failure);
      }
      this.$bvModal.hide("addPhase");
    },
  },
};
</script>

<style scoped>
.card-header-with-icons {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.form_error {
  border: 1px solid red !important;
}

.dropzone-container {
  padding-top: 20px;
  height: 60%;
  width: 60%;
}

.editor-container {
  position: relative;
}

.image-modal-container .image img {
  max-width: 100%;
  max-height: 100%;
}

.image-modal-container .image {
  margin: auto;
}

.image-modal-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.image-modal-container .text {
  margin-top: 20px;
  margin-bottom: 20px;
}

.phasen-image-container {
  margin-bottom: 10px;
  width: 100%;
}
</style>
